var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var breaks = {
    huge: '1440px',
    large: '1024px',
    medium: '768px',
    small: '480px',
    xSmall: '320px'
};
var less = {
    lessThanHuge: "(max-width: ".concat(breaks.huge, ")"),
    lessThanLarge: "(max-width: ".concat(breaks.large, ")"),
    lessThanMedium: "(max-width: ".concat(breaks.medium, ")"),
    lessThanSmall: "(max-width: ".concat(breaks.small, ")"),
    lessThanXSmall: "(max-width: ".concat(breaks.xSmall, ")")
};
var great = {
    greaterThanHuge: "(min-width: ".concat(breaks.huge, ")"),
    greaterThanLarge: "(min-width: ".concat(breaks.large, ")"),
    greaterThanMedium: "(min-width: ".concat(breaks.medium, ")"),
    greaterThanSmall: "(min-width: ".concat(breaks.small, ")"),
    greaterThanXSmall: "(min-width: ".concat(breaks.xSmall, ")")
};
var between = {
    betweenSmallMedium: "".concat(great.greaterThanSmall, " and ").concat(less.lessThanMedium),
    betweenMediumLarge: "".concat(great.greaterThanMedium, " and ").concat(less.lessThanLarge),
    betweenLargeHuge: "".concat(great.greaterThanLarge, " and ").concat(less.lessThanHuge)
};
export default __assign(__assign(__assign(__assign({}, less), great), between), breaks);
